/**
 * 页面按钮
 */

import React, { ReactNode } from 'react';
import classNames from 'classnames';
import styles from './index.module.scss';

interface Props {
  title: string | ReactNode;
  type?: string;
  className?: string;
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
}

export default function Button(props: Props) {
  const { onClick, className, type, title, ...rest } = props;
  const cls = classNames(styles.button, styles[type || 'default'], className);

  return (
    <div className={cls} onClick={onClick} {...rest}>
      <span>{title}</span>
    </div>
  );
}

Button.defaultProps = {
  title: '',
  className: '',
  type: 'default',
  onClick: () => {},
};
